import * as React from "react";
import {Helmet} from "react-helmet";
import BreadcrumbsBlock from "../layouts/breadcrumbs-block/breadcrumbs-block";
import PricingInfoBlock from "../layouts/pricing-info-block/pricing-info-block";
import TitleBlock from "../layouts/title-block/title-block";
import FeaturesBoxSimpleBlock from "../layouts/features-box-simple-block/features-box-simple-block";
import FaqBlock from "../layouts/faq-block/faq-block";
import { GoogleAnalyticsEventType } from "../models/google-analytics";
import {PageType} from "../models/types";
import * as featuresData from "../constants/features-data";
import * as faqQuestionsData from "../constants/faq-questions-data";
import * as helmetData from "../constants/helmet-data";
import * as cacheBustingService from "../services/cache-busting-service";

interface CennikPageProps {}

interface CennikPageState {}

class CennikPage extends React.Component<CennikPageProps,CennikPageState> {

  componentDidMount() {
    cacheBustingService.handleCacheBusting(caches);
  }

  render() {
    return (
      <div>
        <Helmet {...helmetData.prepareHelmetData(PageType.CennikPage)}/>

        <BreadcrumbsBlock
          breadcrumbsElement={
            {
              elementName: "CENNIK USŁUG",
              elementDescription: "PRZYJRZYSTY CENNIK USŁUG"
            }
          }
        />

        <PricingInfoBlock
          componentViewEventType={GoogleAnalyticsEventType.CennikPageViewedMainPricingBlock}
          buttonClickEventType={GoogleAnalyticsEventType.CennikPageClickedCTAAtMainPricingBlock}
          linkClickEventType={GoogleAnalyticsEventType.CennikPageNavigatedToPackagesComparisonPage}
        />

        <TitleBlock
          firstLineBlackStart={"Najważniejsze funkcje"}
          firstLineBlue={"aplikacji"}
          firstLineBlackEnd={""}
          secondLineText={"Zobacz, co otrzymujesz w ramach pakietu."}
        />
        <FeaturesBoxSimpleBlock
          features={featuresData.STANDARD_APP_FEATURES}
          featuresBackground={featuresData.GREY_BACKGROUND_COLOR}
          componentViewEventType={GoogleAnalyticsEventType.CennikPageViewedFeaturesBlock}
        />

        <TitleBlock
          firstLineBlackStart={"Najczęściej zadawane "}
          firstLineBlue={"pytania"}
          firstLineBlackEnd={""}
          secondLineText={"Zapoznaj się odpowiedziami na najczęściej zadawane pytania"}
        />
        <FaqBlock
          faqQuestions={faqQuestionsData.CENNIK_PAGE_FAQ_QUESTIONS}
          componentViewEventType={GoogleAnalyticsEventType.CennikPageViewedFaqBlock}
          faqQuestionReadEventType={GoogleAnalyticsEventType.CennikPageReadFaqQuestion}
        />

      </div>
    )
  }

}

export default CennikPage


// WEBPACK FOOTER //
// ./src/pages/cennik.tsx